<app-fade [show]="show()">
  <div class="spinner">
    <div class="loading">
      <div class="cir c1"></div>
      <div class="cir c2"></div>
      <div class="cir c3"></div>
      <div class="cir c4"></div>
    </div>
  </div>
</app-fade>
